import React, { useEffect , useContext } from 'react';
import L from 'leaflet'
import "leaflet.vectorgrid"
import { useMap } from 'react-leaflet';
import { Context } from '../store/reducer';

/**
 * 63_1: 河川管理情報システム (河川防災情報システム)	土砂災害危険度情報	土砂災害危険度テキストデータ　1kmメッシュ
 * vector + メッシュ情報のデータ読み込みによる表示
 * @param id
 * @param url
 * @param layerName
 * @param color
 * @param opacity
 * @param borderColor
 * @returns {null}
 * @constructor
 */
const VectorGrid63_1 = ({id, url, layerName, color, opacity, borderColor}) => {
    const map =useMap()
    const { state } = useContext(Context);

    useEffect(() => {

        let meshMap = {};
        
        if ( ! state["vis_63_1"].data || ! state["vis_63_1"].data.spots) {
            return <></>;
        }

        // パフォーマンス改善のためkey-valueに変換
        state["vis_63_1"].data.spots.mesh.map(d => {
            meshMap[d.mcode] = d.level
        });

        const vectorGrid = L.vectorGrid.protobuf(url, {
            vectorTileLayerStyles: {
                [layerName]: function(properties){
                    
                    let rankColor = "#FFFFFF";

                    let opacity = state.opacity
                    
                    // 色情報
                    // https://www.d-keikai.pref.hiroshima.lg.jp/readme_download.html
                    if (meshMap[properties.code]) {
                        if (meshMap[properties.code] == 0) {
                            // 値0は表示自体をしない。
                            rankColor = "#FFFFFF"
                            opacity = 0;
                        } else if (meshMap[properties.code] == 1) {
                            rankColor = "#F2E700"
                        } else if (meshMap[properties.code] == 2) {
                            rankColor = "#FF2800"
                        } else if (meshMap[properties.code] == 4) {
                            rankColor = "#AA00AA"
                        } else if (meshMap[properties.code] == 7) {
                            rankColor = "#0C000C"
                        }
                    } else {

                        // 測定していない地域は常に透明表示
                        opacity = 0;
                    }
                    
                    return {
                        color: "#777777",
                        opacity: 0.2, // 1kmメッシュの枠線は薄く常に表示する
                        weight: 1, 
                        fill: true,
                        fillColor: rankColor,
                        fillOpacity: opacity
                    }
                }
            },
        })

        vectorGrid.addTo(map)

        return () => vectorGrid.remove()
    }, [state.opacity])

    return null
}

export default VectorGrid63_1
